import {
  InsufficientCoverageWarning,
  SystemCoverageWarnings
} from 'utils/insufficient-coverage-warning';

type WarningBlockProps = Readonly<{
  warning: InsufficientCoverageWarning;
}>;

function WarningBlock({ warning }: WarningBlockProps) {
  return (
    <div className='flex flex-col gap-1'>
      <div className='font-semibold text-gray-900'>{warning.headline}</div>
      <div>{warning.explanation}</div>
      {warning.details.length > 0 && (
        <ul className='list-disc pl-5'>
          {warning.details.map((detail) => (
            <li key={detail.key}>{detail.text}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

type InsufficientCoverageWarningContentProps = Readonly<{
  entries: SystemCoverageWarnings[];
}>;

export default function InsufficientCoverageWarningContent({
  entries
}: InsufficientCoverageWarningContentProps) {
  const showSystemNames = entries.length > 1;
  return (
    <div className='flex flex-col gap-4 text-left text-sm text-gray-700'>
      {entries.map((entry) => (
        <div key={entry.key} className='flex flex-col gap-3'>
          {showSystemNames && (
            <div className='text-xs font-semibold uppercase tracking-wider text-gray-500'>
              {entry.name}
            </div>
          )}
          {entry.warnings.map((warning) => (
            <WarningBlock key={warning.side} warning={warning} />
          ))}
        </div>
      ))}
    </div>
  );
}
